angular.module('listingOverviewModule').component('listingPricingComparison', {
    templateUrl: 'listingPricingComparison/listingPricingComparison.html',
    bindings: {
        rpcUrl: '@',
        missingImage: '@',
        rpcSaveToProfile: '@',
        saleOrRent: '<'
    },
    controller: ['$element', '$http', function ($element, $http) {
        var self = this;

        this.$postLink = function () {
            const chartElement = $element[0].querySelector('.w_columnchart');

            if (!chartElement) {
                console.warn('Chart element not found.');
                return;
            }

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        //self.loadData(self.rpcUrl);
                        self.initializeColumnChart(chartElement);
                        observer.disconnect();
                    }
                });
            });

            observer.observe(chartElement);
        };

        // this.loadData = function (rpcUrl) {
        //     $http.get(rpcUrl).then((response) => {
        //         console.log('Data loaded:', response.data);
        //         // Handle data if necessary
        //     });
        // };

        this.initializeColumnChart = function (chartElement) {
            const increment = self.saleOrRent === 1 ? 100000 : 1000;

            const col_chart = new ColumnChart(chartElement, {
                increment: increment,
                has_images: false,
                err_img: chartElement.getAttribute('data-missing-image'),
                y_axis: 'Price',
                disp_col: 16,
                height: 350,
                zebra: false,
                main_item_indicator: true,
                scale_px_increment: 30,
                type: 'apts',
                isBuilding: false,
                missingImage: chartElement.getAttribute('data-missing-image'),
                rpcSaveToProfile: chartElement.getAttribute('data-rpc-save-to-profile'),
            });

            col_chart.addEvents({
                notEnoughData: function () {
                    console.warn('Not enough data for the chart.');
                },
                noData: function () {
                    console.error('No data available for the chart.');
                },
            });
        };
    }]
});
